'use strict';

var ScreenSizes = require('../constants/ScreenSizes');

function getStampCountPerRow(screenSize, preferredColumns) {
  switch (preferredColumns) {
  case 3:
    // Keep this synced with .Collection.Collection--3columns
    switch (screenSize) {
    case ScreenSizes.EXTRA_LARGE:
      return 4;
    case ScreenSizes.MEDIUM:
    case ScreenSizes.LARGE:
      return 3;
    default:
    case ScreenSizes.SMALL:
    case ScreenSizes.EXTRA_SMALL:
      return 2;
    }
    break;

  case 4:
    // Keep this synced with .Collection.Collection--4columns
    switch (screenSize) {
    case ScreenSizes.EXTRA_LARGE:
      return 5;
    case ScreenSizes.MEDIUM:
    case ScreenSizes.LARGE:
      return 4;
    case ScreenSizes.SMALL:
      return 3;
    default:
    case ScreenSizes.EXTRA_SMALL:
      return 2;
    }
    break;

  default:
    throw new Error('We only care about 3 and 4 columns for now.');
  }
}

module.exports = getStampCountPerRow;


/** WEBPACK FOOTER **
 ** ./utils/getStampCountPerRow.js
 **/